import 'leaflet';

class Map extends React.Component {
  componentDidMount () {
    const locationLayer = new L.FeatureGroup();
    const markerTemp = L.marker();

    const iconSettings = {
      mapIconUrl: '<svg xmlns="http://www.w3.org/2000/svg" width="147" height="176.52" viewBox="0 0 147 176.52"><g><path fill="{mapIconColor}" d="M125,22l-6-6A69.06,69.06,0,0,0,73,0,69,69,0,0,0,22,22,70,70,0,0,0,0,73c0,21,7,38,22,52l43,47c6,6,11,6,16,0l48-51q18-19.5,18-48C147,53,139,36,125,22Z"/></g></svg>',
      mapIconColor: '#aac600',
    };

    this.markerIcon = L.divIcon({
      className: "map-marker-icon",
      html: L.Util.template(iconSettings.mapIconUrl, iconSettings),
      iconAnchor  : [15, 36],
      iconSize    : [30, 36],
      popupAnchor : [0, -28]
    });

    setTimeout(() => {
      this.map = L.map(`map-${this.props.clientId}`).setView([this.props.latitude, this.props.longitude], this.props.zoom );

      this.marker = L.marker([this.props.latitude, this.props.longitude], {icon: this.markerIcon});

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      }).addTo(this.map);

      if(this.props.marker){
        this.marker.addTo(this.map).bindPopup(this.props.markerText);
      }else{
        this.marker.remove();
      }
    }, 250);
  }

  componentDidUpdate () {
    setTimeout(() => {
      this.map.panTo(new L.LatLng(this.props.latitude, this.props.longitude));
      this.map.setZoom(this.props.zoom);
      if(this.props.marker){
        this.marker.remove();
        this.marker.setLatLng([this.props.latitude, this.props.longitude]);
        this.marker.addTo(this.map).bindPopup(this.props.markerText);
      }else{
        this.marker.remove();
      }
    }, 350);
  }

  render () {
    return (
      <div id={ `map-${this.props.clientId}` } className={ 'map-container' } />
    );
  }
}

export default Map;
